/**
 * Given a selected calendar day, return the ISO bounds [start, end) of that
 * day in local time, for filtering the runs feed. Returns null when no day is
 * selected (feed shows all runs).
 */
export function dayRange(
  date: Date | undefined,
): { from: string; to: string } | null {
  if (!date) return null;
  const from = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    0,
    0,
    0,
    0,
  );
  const to = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate() + 1,
    0,
    0,
    0,
    0,
  );
  return { from: from.toISOString(), to: to.toISOString() };
}

/** Local YYYY-MM-DD key for grouping/comparing dates in the calendar. */
export function dayKey(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}
